import { createContext } from "react";

const CommonContext = createContext({
    theme: {
        mode: null,
        styles: {
            backgroundColor: null,
            color: null,
        },
    },
});

export default CommonContext;
